exports.siteConfig = {
  title: "Cédric Delpoux",
  url: "https://cedricdelpoux.fr",
}
